import React from 'react';
import PropTypes from 'prop-types';

import { entityType, featureTypesType, fieldsType } from 'types';
import Feature from './components/Feature';

import './style.scss';

const Features = ({ fields, currentEntity, featureTypes }) => (
  <div data-test="features">
    <span styleName="features-title">FEATURES</span>
    {fields.map((field, index) => (
      <Feature
        key={`${field}.id`}
        name={`${field}.name`}
        feature_type={`${field}.feature_type`}
        public={`${field}.public`}
        archived={`${field}.archived`}
        types={featureTypes}
        currentEntity={currentEntity}
        item={fields.get(index)}
        onDelete={() => fields.remove(index)}
        // Means that newly created feature isn't created yet
        isNotSynchronized={!fields.get(index).id}
      />
    ))}
  </div>
);

Features.propTypes = {
  /* eslint-disable react/no-typos */
  currentEntity: entityType.isRequired,
  featureTypes: PropTypes.arrayOf(featureTypesType).isRequired,
  fields: fieldsType.isRequired,
};

export default Features;
